import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { ExtraCharge, ExtraChargesType } from '@/redux/modules/billingManagement/extraCharges/extraCharges.types';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from '@/redux/modules/config';
import { getExtraChargesTypes } from '@/redux/modules/billingManagement/extraCharges/extraCharges.selectors';
import { getExtraChargeTypes, postExtraCharge } from '@/redux/modules/billingManagement/extraCharges/extraCharges.api';

export const fetchExtraChargeTypes = createAsyncThunk<ExtraChargesType[], void>(
    'la/ui/extraCharges/fetchExtraChargeTypes',
    async (_, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);

        const { payload } = await getExtraChargeTypes({
            authToken,
            deployment,
        });
        return payload;
    },
    {
        condition: (_, { getState }) => {
            const state = getState();
            const chargeTypes = getExtraChargesTypes(state);
            return chargeTypes?.length === 0;
        },
    }
);

export const saveExtraCharge = createAsyncThunk<
    ExtraCharge,
    Omit<Parameters<typeof postExtraCharge>[0], 'authToken' | 'deployment'>
>('la/ui/extraCharges/saveExtraCharge', async (body, { getState }) => {
    const state = getState();
    const authToken = getAuthToken(state);
    const deployment = getDeployment(state);

    const { payload } = await postExtraCharge({
        ...body,
        authToken,
        deployment,
    });
    return payload;
});
